import React, { ChangeEvent, memo } from 'react';
import ButtonFix from '../ButtonFix';
import useStyles from './styles';

export interface IRow {
  title: string,
  content: string
}
interface ITableDetailComponent {
  handleFix?: (event: ChangeEvent<HTMLSelectElement>) => void;
  list: IRow[];
  showButtonFix?: boolean;
  handleBackStep?: () => void;
}

const TableDetail: React.FC<ITableDetailComponent> = ({
  handleFix, list = [], showButtonFix = true, handleBackStep,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.tableComponent}>
      <div className={classes.tableComponent_Wrapper}>
        {list && list.map((item: IRow) => (
          <dl className={classes.tableComponent_Wrapper_dl}>
            <dt className={classes.tableComponent_Wrapper_dt}>
              <span className={classes.tableComponent_Wrapper_title}>{item?.title || ''}</span>
            </dt>
            <dd className={classes.tableComponent_Wrapper_dd}>
              <p className={classes.tableComponent_Wrapper_content}>
                {item?.content || ''}
              </p>
            </dd>
          </dl>
        ))}
      </div>
      { showButtonFix && (<ButtonFix onClick={() => { handleBackStep && handleBackStep(); }} btnContent="修正する" />)}
    </div>
  );
};

export default memo(TableDetail);
